import { PayloadAction } from "@reduxjs/toolkit";
import { call, put, select, takeEvery } from "redux-saga/effects";
import { setIsEzCheckHistoryInprogress, setIsEzCheckHistoryCompleted, setEZCheckHistory, setIsCreateDealerActionInprogress, setIsCreateDealerActionCompleted, setIsLicenseHistoryCompleted, setLicenseHistory, setIsLicenseHistoryInProgress, setIsDealerProfileEditEmailSended, setIsSendingDealerProfileEditEmail, setIsLicenseRemoved, setEmailErrorState, setNewContactDetailsError, setContactDetailsError, setContactDetailsEdit, setCustomAddressEdit, setDefaultShippingAddressEdited, setIsShootingRevert, setSuggestedResult, setSuggestedResultLoading, setRefreshSerpEnrichmentLoading,setBouncedEmailErrorState, setSavedFilterCollectionsLoading, setSavedFilterCollections, setSavedFilterSuccessEvent, callToGetSavedFilterCollections, callToUpsertSavedFilterCollection, callToDeleteSavedFilterCollection } from "./slice";
import { EditValuesToBeSavedInterface } from "@/model/editDetails.mjs";
import { LicenseHistoryList, RemoveLicensePayload, callToGetLicenseHistoryPayload } from "@/model/licenseHistory.mjs";
import { ToasterNotification } from "@/toaster/toasterNotification";
import { bioTypeUpdate, ContactDetail, CustomAddress, licenseAttributeTypeUpdate, operationalStatusUpdateType } from "../types";
import { createContactDetails, createDealerActions, deleteContactDetails, getEZCheckValidatorHistory, getLicenseHistory, sendEditProfileEmail, updateContactDetailList, removeLicense, createCustomAddress, deleteCustomAddress, updateCustomAddressList, updateDefaultShippingAddress, changeShootingRange, getSuggestedResult, refreshSerpEnrichmentApi, getDealerFilterCollections, upsertDealerFilterCollection, deleteDealerFilterCollection } from "@/api/apis";
import { coerceSavedFilterCollectionsToArray } from "@/explore/savedFilterCollections";
import { Axios, AxiosResponse, isAxiosError } from "axios";
import { callToGetEZCheckValidatorHistoryPayload, ezCheckHistoryResponse } from "@/model/explore";
import { DefaultShippingAddress } from "@/model/licensee.mjs";
import { SimpleToasterNotification } from "@/toaster/successNotification";
import { callToGetDealerDetail, setIsNewProfileLicenseRemoved, toggleLoading } from "@/dealerProfile/ducks/slice";
import { ServicesTypeUpdate } from "@/dealerProfile/edit-dealer-profile/schema";
function* getEZHistory(action: PayloadAction<callToGetEZCheckValidatorHistoryPayload>) {
    try {
        yield put(setIsEzCheckHistoryInprogress(true));
        const response: AxiosResponse<ezCheckHistoryResponse> = yield call(getEZCheckValidatorHistory, action.payload);
        if (response?.data?.historyList && response?.data?.historyList.length > 0) {
            yield put(setEZCheckHistory(response?.data?.historyList));
            yield put(setIsEzCheckHistoryCompleted(true));
        }
    } catch (error) {
        console.log("error", error);
    } finally {
        yield put(setIsEzCheckHistoryInprogress(false));
    }
}

function* getLicenseHistoryList(action: PayloadAction<callToGetLicenseHistoryPayload>) {
    try {

        yield put(setIsLicenseHistoryInProgress(true));
        const response: AxiosResponse<LicenseHistoryList> = yield call(getLicenseHistory, action.payload);
        console.log(response)
        if (response?.data?.dealerData && response?.data?.dealerData.length > 0) {
            console.log({ response: response.data.dealerData })
            yield put(setLicenseHistory(response?.data?.dealerData));
            yield put(setIsLicenseHistoryCompleted(true));
        }
    } catch (error) {
        console.log("error", error);
    } finally {
        yield put(setIsLicenseHistoryInProgress(false));
    }
}

function* removeLicenseHandler(action: PayloadAction<RemoveLicensePayload>) {
    try {
        const payload = {
            license_key: action.payload.license_key,
            type: action.payload.type
        }
        const response: AxiosResponse<{}> = yield call(removeLicense, payload);
        if (response?.status == 204) {
            ToasterNotification("success", `${payload?.type?.toLowerCase()} has been removed.`);
            const dealerId = action.payload.dealerId;
            if (dealerId) {
                yield put(toggleLoading());
                yield put(callToGetDealerDetail(dealerId))
                yield put(setIsNewProfileLicenseRemoved(true));
            }
        }
        yield put(setIsLicenseRemoved(response?.status !== 204));
    } catch (error) {
        console.log("error", error);
    }
}

function* refreshSerpEnrichment(action: PayloadAction<{ license_key: string }>) {
    try {
        yield put(setRefreshSerpEnrichmentLoading(true));
        const payload = {
            license_key: action.payload.license_key
        }
        yield call(refreshSerpEnrichmentApi, payload);
    } catch (error) {
        console.log("error", error);
    } finally {
        yield put(setRefreshSerpEnrichmentLoading(false));
    }
}


function* createDealerActionHandler(action: PayloadAction<{
    actionList: Array<EditValuesToBeSavedInterface>, addContactDetailsPayload?: { data: Array<ContactDetail>, licenseKey: string }, addCustomAddressPayload?: { data: Array<CustomAddress>, licenseKey: string }, removeContactDetailsIds?: Array<number>, removeCustomAddressIds?: Array<number>, updateContactDetails: Array<ContactDetail>, updateCustomAddress: Array<CustomAddress>, licenseKey: string, dealerId: string,
    servicesUpdatePayload?: ServicesTypeUpdate[],
    defaultShippingAddress: DefaultShippingAddress, 
    socialLinksUpdatePayload?: {
        [socialLinksName: string]: string | null | undefined,
        source: string,
        name: string,
        license_key: string
    }[], operationalStatusUpdate:operationalStatusUpdateType[],
    licenseAttributeUpdatePayload?:licenseAttributeTypeUpdate[],
    bioUpdatePayload?: bioTypeUpdate[], 
    sotUpdate:any
}>) {
    try {
        console.log('coming to saga')
        yield put(setIsCreateDealerActionInprogress(true));
        let { actionList, addContactDetailsPayload, addCustomAddressPayload, removeContactDetailsIds, removeCustomAddressIds, updateContactDetails, updateCustomAddress, licenseKey, dealerId, defaultShippingAddress,socialLinksUpdatePayload, operationalStatusUpdate, servicesUpdatePayload,licenseAttributeUpdatePayload,bioUpdatePayload, sotUpdate } = action.payload;
        let dealerActionResponse: number | undefined,
        addContactDetailsResponse: AxiosResponse<Array<{contact_details: ContactDetail, id: number}>> | undefined,
        addCustomAddressResponse: AxiosResponse<Array<CustomAddress>> | undefined,
        deleteContactDetailsResponse: AxiosResponse<any> | undefined,
        deleteCustomAddressResponse: AxiosResponse<any> | undefined,
        updateContactDetailsResponse:  AxiosResponse<any> | undefined,
        updateCustomAddressResponse: AxiosResponse<any> | undefined
        
        if(actionList && actionList.length > 0) {
            actionList = actionList.map((actionItem) => {
                const { id, error, allowAsValidEmailVisible,  ...rest } = actionItem;
                return rest;
            })
            dealerActionResponse = yield call(createDealerActions, actionList);
            if((actionList[0].name === 'preferred' || actionList[0].name === 'blacklisted') && dealerActionResponse == 200){
                const {name,value} = actionList[0]
                if(name === 'preferred' && value === true) ToasterNotification("success", `Dealer Marked as Preferred Successfully.`);
                else if(name === 'preferred' && value === false) ToasterNotification("success", `Dealer Unmarked as Preferred Successfully.`);
                else if(name === 'blacklisted' && value === true) ToasterNotification("success", `Dealer Marked as Blacklisted Successfully.`)
                else if(name === 'blacklisted' && value === false) ToasterNotification("success", `Dealer Unmarked as Blacklisted Successfully.`)
            }
        }
        if (socialLinksUpdatePayload) {
            dealerActionResponse = yield call(createDealerActions, socialLinksUpdatePayload);
        }
        if(addContactDetailsPayload) {
            addContactDetailsPayload.data = addContactDetailsPayload.data.map((contactDetailInfo) => {
                const { allowAsValidEmailVisible, ...contactDetail} = contactDetailInfo;
                contactDetail.phone = contactDetail.phone ? contactDetail.phone.filter((phoneItem) => phoneItem.value) : [];
                return contactDetail;
            })
            addContactDetailsResponse = yield call(createContactDetails, addContactDetailsPayload);
            if(addContactDetailsResponse?.status === 200) {
                let responseList = addContactDetailsResponse.data;
                const newList = responseList && responseList.length > 0 ? responseList.map((contactDetail) => {
                    const { contact_details, id } = contactDetail;
                    return { ...contact_details, id }
                }) : []
                yield put(setContactDetailsEdit([...(newList || [])]))
            }
        }

        if(addCustomAddressPayload) {
            addCustomAddressResponse = yield call(createCustomAddress, addCustomAddressPayload);
            if(addCustomAddressResponse?.status === 200) {
                let responseList:CustomAddress[] = addCustomAddressResponse?.data && addCustomAddressResponse.data.length ? addCustomAddressResponse.data : [];
                yield put(setCustomAddressEdit(responseList));
            }
        }

        if(removeContactDetailsIds && removeContactDetailsIds.length > 0) {
            deleteContactDetailsResponse = yield call(deleteContactDetails, removeContactDetailsIds, licenseKey);
        }
        if(removeCustomAddressIds && removeCustomAddressIds.length > 0) {
            deleteCustomAddressResponse = yield call(deleteCustomAddress, removeCustomAddressIds, licenseKey);
        }
        if(updateContactDetails && updateContactDetails.length > 0) {
            updateContactDetails = updateContactDetails.map((contactDetailInfo) => {
                const { allowAsValidEmailVisible, ...contactDetail} = contactDetailInfo;
                return contactDetail;
            })
            updateContactDetailsResponse = yield call(updateContactDetailList, formatContactDetailsUpdatePayload(updateContactDetails), licenseKey);
        }
        if(updateCustomAddress && updateCustomAddress.length > 0) {
            updateCustomAddressResponse = yield call(updateCustomAddressList, formatCustomAddressUpdatePayload(updateCustomAddress), licenseKey);
        }
        if (servicesUpdatePayload) {
            dealerActionResponse = yield call(createDealerActions, servicesUpdatePayload);
        }
        if (operationalStatusUpdate) {
            dealerActionResponse = yield call(createDealerActions, operationalStatusUpdate);
        }
        if (licenseAttributeUpdatePayload) {
            dealerActionResponse = yield call(createDealerActions, licenseAttributeUpdatePayload)
        }
        if(bioUpdatePayload){
            dealerActionResponse = yield call(createDealerActions, bioUpdatePayload)
        }
        if (sotUpdate && sotUpdate.length > 0) {
            dealerActionResponse = yield call(createDealerActions, sotUpdate);
        }
        yield put(setIsCreateDealerActionCompleted(true));
        if(dealerId) yield put(callToGetDealerDetail(dealerId))
    } catch (error: any) {
        console.log("error : ", error);
        if(isAxiosError(error)) {
            if(error?.response && error?.response?.data && error?.response.data.error && error.request.responseURL.includes('/contact-details') && error.response?.config.method === "post") {
                yield put(setNewContactDetailsError(error?.response.data.error))
            }
            if(error?.response && error?.response?.data && error?.response.data.error && error.request.responseURL.includes('/contact-details') && error.response?.config.method === "put") {
                yield put(setContactDetailsError(error?.response.data.error))
            }
            if(error?.response && error.response?.data && error.response.data?.Error && error.request.responseURL.includes('/dealer/actions')){
                if (error.response.status === 400   ) {
                const message = error.response.data?.Error?.replace(/^Error:\s*/, "")
                  yield put(setBouncedEmailErrorState(message));
                }else{
                const emailErr = JSON.parse(error.response.data?.Error);
                yield put(setEmailErrorState(emailErr)); 
                }
            }
        }
        yield put(setIsCreateDealerActionInprogress(false));
    } finally {
        yield put(setIsCreateDealerActionInprogress(false));
    }
}

const formatContactDetailsUpdatePayload = (contactDetails: Array<ContactDetail>): Array<{id?: number, contact_details: ContactDetail}> => {
    const updatedList = contactDetails.map((contactDetail) => {
        const { id, ...rest } = contactDetail;
        return { id, contact_details: rest }
    })
    return updatedList;
}

const formatCustomAddressUpdatePayload = (customAddress: Array<CustomAddress>): Array<{id?: number, dealer_addresses: CustomAddress}> => {
    const updatedList = customAddress.map((customAddress) => {
        const { id, ...rest } = customAddress;
        return { id, dealer_addresses: rest }
    })
    return updatedList;
}

function* sendProfileEditEmail(action: PayloadAction<{ license_key: string }>) {
    try {
        yield put(setIsSendingDealerProfileEditEmail(true));
        const response: AxiosResponse<{}> = yield call(sendEditProfileEmail, action.payload);
        if (response.status === 200) {
            yield put(setIsDealerProfileEditEmailSended(true));
        }
    } catch (error) {
        console.log("error", error);
    } finally {
        yield put(setIsSendingDealerProfileEditEmail(false));
    }
}

function* callToShootingChange(action: PayloadAction<any>) {
    try {
        const response: AxiosResponse<{}> = yield call(changeShootingRange, action.payload);
        if (response?.status == 200) {
            SimpleToasterNotification(
                'success',
                `Shooting range changed successfully.`
              );
        }
        yield put(setIsShootingRevert(response?.status !== 200));
    } catch (error) {
        console.log("error", error);
    }
}


function* callToSuggestedResult(action: PayloadAction<any>) {
    try {
        yield put(setSuggestedResultLoading(true));
        let response: AxiosResponse<any> = yield call(getSuggestedResult, action.payload);
        if (response?.status == 200) {
            response = (response?.data?.data as any)?.map((s: any) => {
                const matchedLicenseKey = s.fullLicenseKeys?.length > 1 ? s.fullLicenseKeys.find((licenseKey :any) => licenseKey.includes(action.payload)) : (s.fullLicenseKeys[0] || "")
                return {...s, fullLicenseKey: matchedLicenseKey}
            });
            yield put(setSuggestedResult(response));
        }
    } catch (error) {
        console.log("error", error);
    } finally {
        yield put(setSuggestedResultLoading(false));
    }
}

function* getSavedFilterCollectionsHandler(action: PayloadAction<{ type: string }>) {
    try {
        yield put(setSavedFilterCollectionsLoading(true));
        const response: AxiosResponse<any> = yield call(getDealerFilterCollections, action.payload.type);
        if (response?.status === 200) {
            const raw = response?.data?.data ?? response?.data;
            yield put(setSavedFilterCollections(coerceSavedFilterCollectionsToArray(raw)));
        }
    } catch (error) {
        console.log("error", error);
    } finally {
        yield put(setSavedFilterCollectionsLoading(false));
    }
}

function* upsertSavedFilterCollectionHandler(action: PayloadAction<any>) {
    try {
        yield put(setSavedFilterCollectionsLoading(true));
        const { kind, ...upsertPayload } = action.payload ?? {};
        const response: AxiosResponse<any> = yield call(upsertDealerFilterCollection, upsertPayload);
        if (response?.status === 200 || response?.status === 201) {
            const successKind =
                kind === 'update' || action.payload?.id ? 'update' : 'save';
            yield put(
              setSavedFilterSuccessEvent({
                kind: successKind,
                name: action.payload.name ?? ''
              })
            );
            yield put(callToGetSavedFilterCollections({ type: action.payload.type }));
        }
    } catch (error) {
        console.log("error", error);
    } finally {
        yield put(setSavedFilterCollectionsLoading(false));
    }
}

function* deleteSavedFilterCollectionHandler(action: PayloadAction<{ id: string; type: string; name: string }>) {
    try {
        yield put(setSavedFilterCollectionsLoading(true));
        const response: AxiosResponse<any> = yield call(deleteDealerFilterCollection, action.payload.id);
        if (response?.status === 200 || response?.status === 204) {
            yield put(
              setSavedFilterSuccessEvent({
                kind: 'delete',
                name: action.payload.name ?? ''
              })
            );
            yield put(callToGetSavedFilterCollections({ type: action.payload.type }));
        }
    } catch (error) {
        console.log("error", error);
    } finally {
        yield put(setSavedFilterCollectionsLoading(false));
    }
}

function* watchCallToGetEZCheckValidatorHistory() {
    yield takeEvery("explore/callToGetEZCheckValidatorHistory", getEZHistory);
}

function* watchCallToCreateDealerAction() {
    
    yield takeEvery("explore/callToCreateDealerAction", createDealerActionHandler);
}

function* watchCallToGetLicenseHistory() {
    yield takeEvery("explore/callToGetLicenseHistory", getLicenseHistoryList);
}

function* watchCallToSendProfileEditEmail() {
    yield takeEvery("explore/callToSendProfileEditEmail", sendProfileEditEmail);
}

function* watchCallToRemoveLicense() {
    yield takeEvery("explore/callToRemoveLicense", removeLicenseHandler);
}

function* watchCallToRefreshSerpEnrichment() {
    yield takeEvery("explore/callToRefreshSerpEnrichment", refreshSerpEnrichment);
}
function* watchCallToShootingChange() {
    yield takeEvery("explore/callToShootingChange", callToShootingChange);
}

function* watchCallToSuggestedResult() {
    yield takeEvery("explore/callToSuggestedResult", callToSuggestedResult);
}

function* watchCallToGetSavedFilterCollections() {
    yield takeEvery("explore/callToGetSavedFilterCollections", getSavedFilterCollectionsHandler);
}

function* watchCallToUpsertSavedFilterCollection() {
    yield takeEvery("explore/callToUpsertSavedFilterCollection", upsertSavedFilterCollectionHandler);
}

function* watchCallToDeleteSavedFilterCollection() {
    yield takeEvery("explore/callToDeleteSavedFilterCollection", deleteSavedFilterCollectionHandler);
}


export { watchCallToGetEZCheckValidatorHistory, watchCallToCreateDealerAction, watchCallToGetLicenseHistory, watchCallToSendProfileEditEmail, watchCallToRemoveLicense, watchCallToShootingChange, watchCallToSuggestedResult, watchCallToRefreshSerpEnrichment, watchCallToGetSavedFilterCollections, watchCallToUpsertSavedFilterCollection, watchCallToDeleteSavedFilterCollection }
